import React from 'react';
import { Alert } from 'antd';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import MapboxGL from 'mapbox-gl';

import { updateFeatures, updateRequestGeojson, deleteFeaturesById, getIntersections, getIntersectionsZone, getRouting } from 'modules/userrequest';
import { getActivityExtent, getAllDates, getTidyFeatures, showTooltipOverFeature } from 'helpers/mapHelpers';
import { withLabelProperty, areMatching, addTooltipProperties } from 'helpers/featuresHelpers';
import { getFilters } from 'helpers/activityHelpers';
import FormMap from 'components/FormMap/FormMap';
import MessageEmergency from 'components/FormDate/MessageEmergency';

import styles from './controls.module.scss';

const localPopup = new MapboxGL.Popup({
  anchor: 'bottom',
  offset: 5,
  closeButton: false,
  closeOnClick: false,
});

export class Map extends React.Component {
  state = {
    touched: false,
  };

  componentDidMount () {
    // If there's feature, check
    // if all features already have incidence properties
    // else, make intersect request
    if (this.props.features.length) {
      getTidyFeatures(this.props.features).forEach(feature => {
        this.props.getIntersectionsZone(feature);
      });
      const { activity: { eventDateStart, eventDateEnd } } = this.props;
      this.props.features.forEach(feature => {
        if (!feature.properties.incidence && feature.properties.name !== 'LineString') {
          this.props.getIntersections(feature, eventDateStart, eventDateEnd);
        }
      });
    }
  }

  componentDidUpdate (prevProps) {
    const { activity: { eventDates }, features } = this.props;
    const [dateStart, dateEnd] = getActivityExtent(getAllDates(eventDates));

    if (features.length) {
      this.setTouched();
    }

    features.forEach((feature, index) => {
      const hasFeaturesChanged = prevProps.features.length !== features.length ||
      prevProps.features[index].geometry !== features[index].geometry;

      if (hasFeaturesChanged && feature.properties.name !== 'LineString') {
        this.props.getIntersections(feature, dateStart, dateEnd);
      }
    });
    getTidyFeatures(features).forEach((feature, index) => {
      const hasFeaturesChanged = prevProps.features.length !== features.length ||
      prevProps.features[index].geometry !== features[index].geometry;
      if (hasFeaturesChanged) {
        this.props.getIntersectionsZone(feature);
      }
    });
  }

  setTouched () {
    const { touched } = this.state;
    if (touched) return;
    this.setState({ touched: true });
  }

  get hasError () {
    const { features } = this.props;
    const { touched } = this.state;
    return (!features.length && touched) || features.reduce(
      (has, { properties: { incidence: { GRIDCODE } = {} } = {} }) =>
        has || GRIDCODE === 4,
      false,
    );
  }

  updateFeatures = feature => {
    const featureWithProperties = feature;
    const isValidLineString = feature.geometry.type === 'LineString'
      && feature.geometry.coordinates.length > 1;

    if (isValidLineString) {
      featureWithProperties.properties.routeInProgress = true;
      this.props.getRouting(featureWithProperties);
    }
    this.props.updateFeatures(featureWithProperties);
  }

  updateFeatureName = (targetFeature, label) => {
    const { features } = this.props;
    this.props.updateRequestGeojson({ features: features.map(currentFeature => (
      areMatching(currentFeature, targetFeature)
        ? withLabelProperty(currentFeature, label)
        : currentFeature
    )) });
  };


  render () {
    const { activity, activity: { type, eventDates }, activityTypes } = this.props;
    const activityFilters = getFilters(type, activityTypes);
    const { hasError } = this;

    if (eventDates.length) {
      return (
        <div className={`${styles.locationControl} ${hasError ? styles.locationControl__hasError : ''}`}>
          <MessageEmergency activity={activity} dates={eventDates} />
          <h3>Lieu de l&apos;activité</h3>
          <p>Dessinez un parcours, une zone ou un point en particulier.</p>
          <p>
            <strong>
              Si, pour les dates indiquées ci-dessus,
              vos parcours sont différents, créez une nouvelle activité
            </strong>.
          </p>
          <FormMap
            {...this.props}
            activityDates={eventDates}
            editable
            activityFilters={activityFilters}
            updateFeatures={this.updateFeatures}
            updateFeatureName={this.updateFeatureName}
            deleteFeaturesById={this.props.deleteFeaturesById}
            mapProps={{
              onMouseMove: showTooltipOverFeature(localPopup),
            }}
            features={addTooltipProperties(this.props.features)}
          />
          {hasError &&
            <p className={styles.locationControl__error}>Le lieu de l'activité est invalide</p>
          }
        </div>
      );
    }

    return (
      <Alert
        message="Veuillez valider une date pour tracer votre itinéraire"
        type="warning"
        showIcon
      />
    );
  }
}

const mapStateToProps = state => ({
  activityTypes: state.admin.activities.list,
});

const DispatchToProps = dispatch => bindActionCreators({
  updateFeatures,
  updateRequestGeojson,
  deleteFeaturesById,
  getIntersections,
  getIntersectionsZone,
  getRouting,
}, dispatch);

export default connect(mapStateToProps, DispatchToProps)(Map);



// WEBPACK FOOTER //
// ./src/components/Form/FormActivity/Controls/ControlMap.js